import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { DashboardEquipmentsComponent } from './dashboard-equipments.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.REPORTS.TITLES.EQUIPMENTS' };
var routes = [
    {
        path: 'relatorios/equipamentos',
        component: DashboardEquipmentsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var DashboardEquipmentsModule = /** @class */ (function () {
    function DashboardEquipmentsModule() {
    }
    return DashboardEquipmentsModule;
}());
export { DashboardEquipmentsModule };
export { ɵ0 };
